function initParallaxImages() {
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;

    const allParallax = document.querySelectorAll('.has-intersected .parallax');

    allParallax.forEach(container => {
      const rect = container.getBoundingClientRect();
      const elementOffset = rect.top + window.scrollY;

      const relativeOffset = scrolled - elementOffset;
      const translate = relativeOffset > 0 ? relativeOffset * 0.8 : 0;
      container.style.transform = `translateY(${translate}px)`;
      
    });

    const allInactiveParallax = document.querySelectorAll('.parallax');
    allInactiveParallax.forEach(container => {
      if (!container.closest('.has-intersected')) {
        container.style.transform = '';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initParallaxImages);
